import { createAction } from '@reduxjs/toolkit';

import type { HotelAdminContact } from 'app/redux/models/Hotel/Hotel';
import type { IHotel } from 'app/typings';

export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const UPDATE_HOTEL_ID = 'UPDATE_HOTEL_ID';
export const FETCH_BOOKINGS_CSV_SUCCESS = 'FETCH_BOOKINGS_CSV_SUCCESS';
export const TRY_FETCH_HOTELS = 'TRY_FETCH_HOTELS';
export const FETCH_HOTELS_SUCCESS = 'FETCH_HOTELS_SUCCESS';
export const HOTEL_ADMIN_BILLS_DOWNLOAD_BILL =
  'HOTEL_ADMIN_BILLS_DOWNLOAD_BILL';
export const HOTEL_ADMIN_BILLS_DOWNLOAD_BILL_SUCCESS =
  'HOTEL_ADMIN_BILLS_DOWNLOAD_BILL_SUCCESS';
export const HOTEL_ADMIN_BILLS_DOWNLOAD_BILL_FAILURE =
  'HOTEL_ADMIN_BILLS_DOWNLOAD_BILL_FAILURE';
export const HOTEL_ADMIN_BILLS_RESET_BILL_OBJECT_PDF =
  'HOTEL_ADMIN_BILLS_RESET_BILL_OBJECT_PDF';
export const HOTEL_ADMIN_FETCH_CONTACTS = 'HOTEL_ADMIN_FETCH_CONTACTS';
export const HOTEL_ADMIN_FETCH_CONTACTS_SUCCESS =
  'HOTEL_ADMIN_FETCH_CONTACTS_SUCCESS';
export const HOTEL_ADMIN_FETCH_CONTACTS_FAILED =
  'HOTEL_ADMIN_FETCH_CONTACTS_FAILED';
export const HOTEL_ADMIN_SAVE_CONTACTS = 'HOTEL_ADMIN_SAVE_CONTACTS';
export const HOTEL_ADMIN_SAVE_CONTACTS_SUCCESS =
  'HOTEL_ADMIN_SAVE_CONTACTS_SUCCESS';
export const HOTEL_ADMIN_SAVE_CONTACTS_FAILED =
  'HOTEL_ADMIN_SAVECONTACTS_FAILED';

export type HotelAdminDownloadBillPayload = {
  billId: number;
  hotelId: number;
};

type HotelAdminDownloadBillSuccessPayload = {
  pdf: Blob;
  filename: string;
};

type HotelAdminUpdateHotelIdPayload = {
  hotelId: number;
};

export type HotelAdminTryFetchBookingsPayload = {
  hotelId: number;
  offset: number;
  search?: string;
  sorting?: string;
  beginning?: string;
  ending?: string;
  status?: string[];
};

type HotelAdminFetchBookingsCSVSuccessPayload = {
  result: unknown;
};

type HotelAdminFetchHotelsSuccessPayload = {
  result: IHotel[];
};

type HotelAdminFetchContactPayload = {
  hotelId: number;
};
type HotelAdminFetchContactSuccessPayload = {
  res: HotelAdminContact;
};
type HotelAdminSaveContactPayload = {
  hotelId: number;
  form: HotelAdminContact;
};
type HotelAdminSaveContactSuccessPayload = {
  res: HotelAdminContact;
};

export const startLoading = createAction(START_LOADING);
export const stopLoading = createAction(STOP_LOADING);

export const updateHotelId =
  createAction<HotelAdminUpdateHotelIdPayload>(UPDATE_HOTEL_ID);

export const fetchBookingsCSVSuccess =
  createAction<HotelAdminFetchBookingsCSVSuccessPayload>(
    FETCH_BOOKINGS_CSV_SUCCESS
  );

export const tryFetchHotels = createAction(TRY_FETCH_HOTELS);

export const fetchHotelsSuccess =
  createAction<HotelAdminFetchHotelsSuccessPayload>(FETCH_HOTELS_SUCCESS);

export const downloadBill = createAction<HotelAdminDownloadBillPayload>(
  HOTEL_ADMIN_BILLS_DOWNLOAD_BILL
);
export const downloadBillSuccess =
  createAction<HotelAdminDownloadBillSuccessPayload>(
    HOTEL_ADMIN_BILLS_DOWNLOAD_BILL_SUCCESS
  );
export const downloadBillFailure = createAction(
  HOTEL_ADMIN_BILLS_DOWNLOAD_BILL_FAILURE
);

export const resetBillObjectPdf = createAction(
  HOTEL_ADMIN_BILLS_RESET_BILL_OBJECT_PDF
);

export const fetchContacts = createAction<HotelAdminFetchContactPayload>(
  HOTEL_ADMIN_FETCH_CONTACTS
);

export const fetchContactsSuccess =
  createAction<HotelAdminFetchContactSuccessPayload>(
    HOTEL_ADMIN_FETCH_CONTACTS_SUCCESS
  );

export const fetchContactsFailed = createAction(
  HOTEL_ADMIN_FETCH_CONTACTS_FAILED
);

export const saveContacts = createAction<HotelAdminSaveContactPayload>(
  HOTEL_ADMIN_SAVE_CONTACTS
);

export const saveContactsSuccess =
  createAction<HotelAdminSaveContactSuccessPayload>(
    HOTEL_ADMIN_SAVE_CONTACTS_SUCCESS
  );

export const saveContactsFailed = createAction(
  HOTEL_ADMIN_SAVE_CONTACTS_FAILED
);
